import React, {useState, useRef, useEffect, Fragment} from 'react';
import TitleWithIcon from '../TitleWithIcon'
import VisDiv from '../frontend_components/VisDiv'
import Divider from '../frontend_components/Divider'
import OfferTotals from './OfferTotals'
import {IoIosEye, IoIosEyeOff, IoMdCart } from 'react-icons/io';
import { useStateContext } from '../../context/StateContext';
import UpdateOfferFromRegister from './UpdateOfferFromRegister';
import { mergeArraysById } from '../../lib/utils';
import { referenceDoc } from '../gestioneDatabase/Docs';
import Swal from 'sweetalert2';


const RegisterHeader = ({data={}, hideShowRegister = () => {}}) => {
 //#offerTotals
 const {clientOrder, register, siteOffer, registerTemplate, offerDataWithSigns, offerTotals, productsMissing, iconLink, infoProducts, offerData, reportData} = data  

 //const {offer, setOffer, setIsEditingOffer, forceReload, forceLoad,} = useStateContext()
 //console.log("IN CONSOLE HEADER", registerTemplate)
 const [showMissing, setShowMissing] = useState(false)
 const workedData = offerDataWithSigns ? offerDataWithSigns : offerData
 const onRowClick = () => {
  console.log("CLICKED REGISTER ROW", workedData, register)
 }
 //console.log("CLICKED REGISTER ROW", data)
 const registerName = register?.registerName? register?.registerName: ""
 const offerTitle = registerTemplate?.offerTitle ? registerTemplate?.offerTitle : registerTemplate?.family
 const registerFullName = `${offerTitle} ${registerName}`
const registerId = () => 
  { 
    const isSignRegister = offerDataWithSigns?.length > 0
    if(isSignRegister) return "weduwheiudghyegwuyjke88363ghdloiejdf87"
    return register?._id
  }
const allProductsHidden = workedData?.every?.((x)=>x?.hide)
const isRegisterHidden = siteOffer?.hideRegisters?.some?.((y)=> y == registerId())

const orderWorkedData = !Array.isArray(workedData) ? [] : workedData?.filter?.((x)=>{
  return x?.clientOrder?._ref == clientOrder?._id || !x?.clientOrder
})
const areAllInThisOrder = orderWorkedData?.every?.((x)=>x?.clientOrder)

const addToOrder = () => { 
  console.log("ADD TO ORDER", orderWorkedData)
  const allOrder = orderWorkedData?.map?.((item)=>({...item, clientOrder: referenceDoc(clientOrder?._id)}))
  const updatedData = mergeArraysById(workedData, allOrder)
  const updatedFieldsData = mergeArraysById(siteOffer?.offerFields, updatedData)
  const updatedOfferDoc = {...siteOffer, offerFields: updatedFieldsData}
  hideShowRegister(updatedOfferDoc)
}
const removeFromOrder = () => { 
  console.log("REMOVE FROM ORDER", orderWorkedData)
  const allOrder = orderWorkedData?.map?.((item)=>({...item, clientOrder: undefined}))
  const updatedData = mergeArraysById(workedData, allOrder)
  const updatedFieldsData = mergeArraysById(siteOffer?.offerFields, updatedData)
  const updatedOfferDoc = {...siteOffer, offerFields: updatedFieldsData}
  hideShowRegister(updatedOfferDoc)
}

 const showRegister = () => {
  //#showHideOffer
  console.log("SHOW REGISTER", siteOffer)
  if(!siteOffer){
    console.log("NO SITE OFFER FOUND")
    return
  }
  const hideRegister = {
    ...siteOffer,
    hideRegisters:[...!Array.isArray(siteOffer?.hideRegisters) ? [] : siteOffer?.hideRegisters?.filter?.((x)=>x != registerId())]
  }
  hideShowRegister(hideRegister)

 }
 const hideRegister = () => {
  //#showHideOffer
  console.log("Hide REGISTER", siteOffer)

  if(!siteOffer){
    console.log("NO SITE OFFER FOUND")
    return
  }
  const hideRegister = {
    ...siteOffer,
    hideRegisters:[...!Array.isArray(siteOffer?.hideRegisters) ? [] : siteOffer?.hideRegisters, registerId()]
  }
  hideShowRegister(hideRegister)

 }

 const addFields = async(data) => {
   console.log("FIELDS TO ADD IN REGISTER HEADER", data)
   const updatedFieldsData = !Array.isArray(siteOffer?.offerFields) ? [] : [...siteOffer?.offerFields, ...data]
   const updatedOfferDoc = {...siteOffer, offerFields: updatedFieldsData}
   console.log("FIELDS TO ADD IN REGISTER HEADER", {updatedFieldsDataFiltered: updatedFieldsData?.filter?.((x=>x)), updatedFieldsData, newFields: data, offer: siteOffer, updatedOfferDoc})
   hideShowRegister(updatedOfferDoc)
   Swal.fire({
    position: 'top',
    icon: 'success',
    title: "RICARICA LA PAGINA",
    showConfirmButton: false,
    timer: 1500
  })
 }
 const headerBackground = () => {
  if(register?.status == "ARCHIVIATO") return "lightgrey"
  if(register?.notInMaintenance) return "#FFDBBB"
  return "transparent"
 }
 //console.log("CUSTOMER PRODUCT NON TROVATO", productsMissing)
 return (
   <div onClick={onRowClick}>
      <Divider/> 
      <div className='dskh-siteinfo' style={{backgroundColor: headerBackground(),}}>  
        <VisDiv  rules={[!clientOrder]} className='side' style={{alignItems:"center"}}>
          <VisDiv rules={[workedData?.length>0]} style={{color:"darkBlue", cursor:"pointer", marginLeft:"10px"}}>
            <VisDiv className='round-back-button' style={{backgroundColor:"grey", width: "40px", height: "40px"}} rules={[isRegisterHidden]} onClick={(e) => {showRegister()}}>
              <IoIosEyeOff fontSize={25} color='white'/>
            </VisDiv>
            <VisDiv className='round-back-button' style={{backgroundColor:"green", width: "40px", height: "40px"}} rules={[!isRegisterHidden]} onClick={(e) => {hideRegister()}}>
              <IoIosEye fontSize={25} color='white' />
            </VisDiv>
          </VisDiv>
          <VisDiv rules={[siteOffer]} style={{marginLeft: "30px", color:"darkBlue", cursor:"pointer", }}>
           <UpdateOfferFromRegister offerData={workedData} reportData={reportData} addFields={addFields}/>
          </VisDiv>
        </VisDiv>
        <VisDiv  rules={[clientOrder]} className='side' style={{alignItems:"center"}}>
          <VisDiv rules={[!areAllInThisOrder]} className='round-back-button' style={{backgroundColor:"grey", width: "40px", height: "40px"}}  onClick={(e) => {addToOrder()}}>
            <IoMdCart fontSize={25} color='white'/>
          </VisDiv>
          <VisDiv rules={[areAllInThisOrder]} className='round-back-button' style={{backgroundColor:"green", width: "40px", height: "40px"}} onClick={(e) => {removeFromOrder()}}>
            <IoMdCart fontSize={25} color='white' />
          </VisDiv>
        </VisDiv>
        <div className='center' style={{flexDirection:"column", alignItems:"center", flex:1}} > 
          <div style={{display:"flex", alignItems:"center"}}>
            <VisDiv rules={[iconLink]}>
              <img src={iconLink} alt="offer-icon" className='offer-icon-image'/> 
            </VisDiv>
            <TitleWithIcon
            iconSize={40}
            fontSize={12}
            icon={registerTemplate?.icon}
            title={registerFullName}
            />
          </div>

          <VisDiv  rules={[register?.status == "ARCHIVIATO"]} style={{color:"red", textAlign:"center"}}>
            <h3>
              ARCHIVIATO
            </h3>
          </VisDiv>
          <VisDiv  rules={[register?.notInMaintenance]} style={{color:"orange", textAlign:"center"}}>
            <h3>
              NON IN MANUTENZIONE
            </h3>
          </VisDiv>
        </div>
        <div className='right-side' style={{display:"flex", flexDirection: "column", alignItems:"flex-end", marginRight:"20px"}}>
          <OfferTotals offerTotals={offerTotals}/>
        </div>
      </div>                          

      <ProductsDropdown customerProductsArray={productsMissing} />
      <ProductsDropdown customerProductsArray={infoProducts} text={"PRODOTTI INFORMATIVI"} barColor={"blue"} />
      <Divider/>
   
   </div>
  )
}

export default RegisterHeader

export const ProductsDropdown = ({customerProductsArray, text = "CI SONO PRODOTTI MANCANTI", barColor = "red"}) => {
  const [show, setShow] = useState(false)
  return (
  <VisDiv rules={[customerProductsArray?.length > 0]}>
    <VisDiv style={{marginTop:"10px",backgroundColor: barColor, color:"white", textAlign:"center"}}  onClick={()=>setShow(!show)}>
      {text}
    </VisDiv>
    <VisDiv rules={[show]}>
          {customerProductsArray?.map?.((item, index)=>{
            const positions = item?.deviceNonConformities?.map?.((obj)=>` Presidio ${obj?.device?.label} in posizione ${obj?.device?.positionNumber}`)
            return (
            <div onClick={()=>console.log("MANCA PRODOTTO", item)} key={index} style={{padding:"10px"}}>
              <VisDiv style={{display:"flex", flexDirection:"column"}}>
                <h3>{item?.label} </h3>
                <p>
                  {positions?.toString()}
                </p>
                <VisDiv rules={[item?.deviceNonConformities?.length<1]}>
                <p>Non ci sono presidi associati</p>
                </VisDiv>
              
              </VisDiv>
            </div>
            )
          })}
    </VisDiv>
      
  </VisDiv>
  )
}

